"use strict";

exports.__esModule = true;
exports["default"] = exports.FilterAndSort = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = require("prop-types");

var _animations = require("@qc-modules/animations");

var _primitives = _interopRequireDefault(require("../../primitives"));

var _components = require("../../components");

var _mobileHeader = _interopRequireDefault(require("./mobile-header"));

var _mobileFooter = _interopRequireDefault(require("./mobile-footer"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var FilterAndSortContainer = (0, _styledComponents["default"])(_primitives["default"].Flex).withConfig({
  displayName: "filter-and-sort__FilterAndSortContainer",
  componentId: "sc-14491xe-0"
})(["@media only screen and (max-width:949px){position:fixed;left:0;top:0;bottom:0;width:100%;z-index:9000;}"]);
var FilterSortBody = (0, _styledComponents["default"])(_primitives["default"].Box).withConfig({
  displayName: "filter-and-sort__FilterSortBody",
  componentId: "sc-14491xe-1"
})(["position:relative;@media only screen and (max-width:949px){overflow-y:auto;overflow-x:hidden;-webkit-overflow-scrolling:touch;&::-webkit-scrollbar{display:none;}width:calc(100% + 20px);scrollbar-width:none;-ms-overflow-style:none;}"]);
var propTypes = {
  /** Object map of filters currently active */
  activeFilters: (0, _propTypes.objectOf)((0, _propTypes.oneOfType)([_propTypes.string, _propTypes.number])),
  // Callback to handle on apply filter
  applyOnClick: _propTypes.func.isRequired,
  // Callback to handle on Cancel filter
  cancelOnClick: _propTypes.func.isRequired,
  // Object map of filters currently disabled
  disabledFilters: (0, _propTypes.objectOf)((0, _propTypes.oneOfType)([_propTypes.string, _propTypes.number])),

  /** Array to be rendered as checkboxes */
  filterGroups: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    /** ID of each filter group, used for key prop */
    id: _propTypes.string.isRequired
  })),

  /** onChange event handler - used to process the filter selection event */
  filterOnChange: _propTypes.func.isRequired,
  // Title for Filters
  filtersTitle: _propTypes.string,
  // Control for display as flex or none
  isActive: _propTypes.bool,
  // Reset filter callback
  resetOnClick: _propTypes.func.isRequired,
  // Total number of results
  resultsCount: _propTypes.number,
  // Selected sorting option
  selectedSortOption: _propTypes.string,
  // Flag to show/hide filters
  showFilters: _propTypes.bool,
  // Flag to show/hide mobile footer
  showMobileFooter: _propTypes.bool,
  // Flag to show reset filter on header
  showReset: _propTypes.bool,
  // Flag to show sort options
  showSortOptions: _propTypes.bool,

  /** sortOnChange event handler - used to process the event */
  sortOnChange: _propTypes.func.isRequired,
  // Sorting options
  sortOptions: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    id: (0, _propTypes.oneOfType)([_propTypes.number, _propTypes.string]),
    label: _propTypes.string,
    value: _propTypes.string
  })),

  /** Label for the sort group */
  sortTitle: _propTypes.string,
  // Mobile header title
  title: _propTypes.string
};
var defaultProps = {
  activeFilters: {},
  disabledFilters: {},
  filterGroups: [],
  filtersTitle: "",
  isActive: false,
  resultsCount: 0,
  selectedSortOption: [],
  showFilters: true,
  showMobileFooter: false,
  showReset: false,
  showSortOptions: true,
  sortOptions: [],
  sortTitle: "",
  title: "Filter & Sort"
};

var FilterAndSort = function FilterAndSort(_ref) {
  var activeFilters = _ref.activeFilters,
      applyOnClick = _ref.applyOnClick,
      cancelOnClick = _ref.cancelOnClick,
      disabledFilters = _ref.disabledFilters,
      filterGroups = _ref.filterGroups,
      filtersTitle = _ref.filtersTitle,
      filterOnChange = _ref.filterOnChange,
      isActive = _ref.isActive,
      resultsCount = _ref.resultsCount,
      resetOnClick = _ref.resetOnClick,
      selectedSortOption = _ref.selectedSortOption,
      showFilters = _ref.showFilters,
      showMobileFooter = _ref.showMobileFooter,
      showReset = _ref.showReset,
      showSortOptions = _ref.showSortOptions,
      sortOnChange = _ref.sortOnChange,
      sortOptions = _ref.sortOptions,
      sortTitle = _ref.sortTitle,
      title = _ref.title;
  return /*#__PURE__*/_react["default"].createElement(FilterAndSortContainer, {
    backgroundColor: ["background-ultra-light", "background-ultra-light", "white"],
    display: isActive ? "flex" : ["none", "none", "flex"],
    flexDirection: "column",
    width: 1
  }, /*#__PURE__*/_react["default"].createElement(_mobileHeader["default"], {
    backgroundColor: "background",
    cancelOnClick: cancelOnClick,
    resetOnClick: resetOnClick,
    resultsCount: resultsCount,
    showReset: showReset,
    textAlign: "center",
    title: title
  }), /*#__PURE__*/_react["default"].createElement(FilterSortBody, {
    height: 1,
    mb: showMobileFooter ? ["60px", "60px", 0] : 0,
    mt: ["75px", "75px", 0],
    pr: ["20px", 0],
    pt: [5, 5, 0],
    width: 1
  }, showSortOptions ? /*#__PURE__*/_react["default"].createElement(_primitives["default"].Flex, {
    width: 1
  }, /*#__PURE__*/_react["default"].createElement(_components.Sort, {
    groupLabel: sortTitle,
    selectedOption: selectedSortOption,
    sortOnChange: sortOnChange,
    sortOptions: sortOptions
  })) : null, showFilters ? /*#__PURE__*/_react["default"].createElement(_primitives["default"].Flex, {
    width: 1
  }, /*#__PURE__*/_react["default"].createElement(_components.Filters, {
    activeFilters: activeFilters,
    disabledFilters: disabledFilters,
    filterGroups: filterGroups,
    filterOnChange: filterOnChange,
    title: filtersTitle
  })) : null), showMobileFooter ? /*#__PURE__*/_react["default"].createElement(_animations.Fade, {
    alwaysShowInDom: false,
    enterDuration: 0.25,
    exitDuration: 0.2,
    show: showMobileFooter
  }, /*#__PURE__*/_react["default"].createElement(_mobileFooter["default"], {
    applyOnClick: applyOnClick
  })) : null);
};

exports.FilterAndSort = FilterAndSort;
FilterAndSort.propTypes = propTypes;
FilterAndSort.defaultProps = defaultProps;
FilterAndSort.displayName = "Modules.FilterAndSort";
var _default = FilterAndSort;
exports["default"] = _default;